import { isEmpty, isEqual, sortBy, uniqueId } from 'underscore';
import { LEGAL_CONSENT_OPTIONS_KEY } from 'FormsCommonComponents/constants/LegalConsent';
// @ts-expect-error: no types
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/0beeb217ebfa591e7103b785376883a3a92a7240/submissions-ui/static/js/lib/Themes.js
 */
class Themes {
  static getDefaultTheme() {
    return 'canvas';
  }
}

/**
 * Taken from: https://git.hubteam.com/HubSpot/submissions-ui/blob/0beeb217ebfa591e7103b785376883a3a92a7240/submissions-ui/static/js/lib/Form.js#L17
 */
const FormKeys = {
  CAPTACHA_ENABLED: 'captchaEnabled',
  CLONEABLE: 'cloneable',
  CREATED_AT: 'createdAt',
  DELETABLE: 'deletable',
  FIELD_PREPOPULATION: 'ignoreCurrentValues',
  FORM_FIELD_GROUPS: 'formFieldGroups',
  GUID: 'guid',
  META_DATA: 'metaData',
  NAME: 'name',
  NOTIFY_RECIPIENTS: 'notifyRecipients',
  REDIRECT_PAGE: 'redirect',
  SUBMIT_TEXT: 'submitText',
  THANK_YOU_MESSAGE: 'inlineMessage',
  THEME_NAME: 'themeName',
  UPDATED_AT: 'updatedAt',
  FORM_TYPE: 'formType',
  STYLE: 'style',
  ALWAYS_CREATE_NEW_COMPANY: 'alwaysCreateNewCompany'
};
const getLegalConsent = value => {
  try {
    return new LegalConsent(JSON.parse(value));
  } catch (error) {
    return {};
  }
};
export const getDefaults = definition => {
  const maybeSetDefaults = {};
  if (isEmpty(definition[FormKeys.THEME_NAME])) {
    maybeSetDefaults[FormKeys.THEME_NAME] = Themes.getDefaultTheme();
  }
  return {
    maybeSetDefaults
  };
};
export const getFormFieldGroups = definition => {
  const formFieldGroupsWithRichTextId = sortBy(definition.formFieldGroups, formFieldGroup => -formFieldGroup.default) // put queued fields at the bottom
  .map(formFieldGroup => {
    return Object.assign({}, formFieldGroup, {
      richText: Object.assign({}, formFieldGroup.richText, {
        privateInternalId: Number(uniqueId())
      })
    });
  });
  return {
    formFieldGroups: formFieldGroupsWithRichTextId
  };
};
export const getMetaData = definition => {
  const parsedMetaData = definition.metaData.map(({
    name,
    value
  }) => Object.assign({
    name
  }, isEqual(name, LEGAL_CONSENT_OPTIONS_KEY) ? {
    value: getLegalConsent(value)
  } : {
    value
  }));
  return {
    metaData: parsedMetaData
  };
};

/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/utils/formDefinition/hydrateFormWithDefaults.js#L62
 */
export function hydrateFormWithDefaults(definition) {
  return Object.assign({}, definition, getDefaults(definition), getFormFieldGroups(definition), getMetaData(definition));
}
export default hydrateFormWithDefaults;